<script>
  let loaderGif = './images/loader.gif'
  import { ethers } from 'ethers'
  import {getContext, onMount,onDestroy} from 'svelte'
  import { formatUnits } from 'ethers/lib/utils'

  import ConnectWallet from '../../ConnectWallet.svelte'
  import { signerAddress,chainId } from 'svelte-ethers-store'

  import { salesQuery } from '../../../../../services/api'
  import { allSaleTransactions } from '../../../../../services/saleTransactionApi'
  import { pop } from 'svelte-spa-router'

  import { signer } from 'svelte-ethers-store'
  import { saleStatuses } from '../../../../contracts/sale.ts'
  import SaleArtifact from '../../../../abi/Sale.json'

  import { addEllipses, formateToPrecision, getUnixTimeStamp,formattedChainID,switchAddNetwork } from '../../../../utils'

  import { getProjectDetailService } from '../../../../../services/projectDetailService'
  import SaleStartModal from '../../../../components/sale-start-modal/SaleStartModal.svelte';

  export let params = {}


  const { open } = getContext("simple-modal");
  
  let sale, projectDetails,
    saleContract,
    reserve,
    token,
    status = 'Pending'

  let canEnd,
    canStart,
    inValid = false

  const fetchProjectDetails = async () => {
      if (!params.projectId) return (inValid = true)
      projectDetails = await getProjectDetailService(params.projectId);
      let {data} = await salesQuery(projectDetails.sale_address, projectDetails.version.version, projectDetails.chain.chain_id);
      if(data?.sales.length == 0) return (inValid = true);
      sale = data?.sales[0];

      if(projectDetails.chain.chain_id == currentChainID)
          loadSaleContract();
  }


 onMount(() => {
    if (window.ethereum) {
      ethereum.on("chainChanged", () => {
        document.location.reload();
      });
    }
  });
  const loadSaleContract = async () => {
      saleContract =  saleContract = new ethers.Contract(
          projectDetails.sale_address,
          SaleArtifact.abi,
          $signer,
        );
    status = saleStatuses[await saleContract.saleStatus()];
    refreshActions();
  }

  const refreshActions = () => {
    canStart = async () => {
          try {
            return await saleContract.canStart()
          } catch (error) {
            return false
          }
        }

        canEnd = async () => {
          try {
            return await saleContract.canEnd()
          } catch (error) {
            return false
          }
        }
  }



  let fetchTransactions = async () => {
    try {
      let response = await allSaleTransactions(projectDetails.sale_address, projectDetails.version.version, projectDetails.chain.chain_id);
      if (response.data.saleTransactions.length > 0) {
        reserve = response.data?.saleTransactions[0]?.saleContract.reserve
        token = response.data?.saleTransactions[0]?.saleContract.token
      }
      return response.data.saleTransactions
    } catch (e) {
      return []
    }
  }

  const typeMap = new Map([
    ['SaleBuy', 'Buy'],
    ['SaleRefund', 'Refund'],
  ])

  $: currentChainID = formattedChainID($chainId);

  fetchProjectDetails()


</script>
<div class="sale-title">
</div>

{#if $signerAddress}
  {#if projectDetails?.sale_address && projectDetails}
    {#if currentChainID != projectDetails.chain.chain_id }
      <div class="unix-modal wrong-net">
        <div class="unix-modal-dialog flex items-center">
          <div class="unix-modal-content flex column-direction">
            <div class="flex items-center flex-text-center column-direction">
              <h2 class="modal-title">Wrong Network</h2>
              <div class="flex items-center justify-center">
                <a id="start-creation-page" href="javascript:void(0)" style="font-weight: 400;" class="flex items-center start-connect-btn btn-gradient-border" on:click={() => switchAddNetwork(projectDetails.chain.chain_id)}>
                  Change Network
                </a>
              </div>
            </div>
            <div   on:click={() => {
              pop()
            }} class="cross-icon">x</div>
          </div>
        </div>
      </div>
      {/if}
    <div class="sale-detail-wrap flex flex-wrap">
      <div class="container">
        <div class="back-project">
          <a id="back-project-page"
            href="javascript:void(0)"
            on:click={() => {
              pop()
            }}
            class="flex items-center">
            <img src="./images/back-arrow.svg" alt="backButton" />
            <p>Go Back to My Projects</p>
          </a>
        </div>

        <div class="sale-productivity flex flex-wrap">
          <div class="col-12 flex">
              <div class="sale-title">
                <h1>{projectDetails.project_name}</h1>
                <p>{projectDetails.project_description}</p>
              </div>
              <a href={`#/project-details/${params.projectId}`} class="ml-auto" style="color: white; text-decoration: underline">Go to Project Detail</a>
          </div>
          <div class="col-12">
            {#if sale}
            <ul class="list-none flex flex-wrap">
              <li>
                Sale Status:
                <span class="ml-auto">{status}</span>
              </li>
              <li>
                Could Start:
                <span class="ml-auto">
                  {getUnixTimeStamp(parseInt(sale.canStartStateConfig.constants[0]), 'MM-DD-YYYY HH:mm:ss')}
                </span>
              </li>
              <li>
                Minimum Raise:
                <span class="ml-auto">
                  {formateToPrecision(Number(+formatUnits(sale.minimumRaise, sale.reserve.decimals)))}
                </span>
              </li>
              <li>
                Can End:
                <span class="ml-auto">
                  {getUnixTimeStamp(parseInt(sale.canEndStateConfig.constants[0]), 'MM-DD-YYYY HH:mm:ss')}
                </span>
              </li>
              <li>
                rTKN available:
                <span class="ml-auto">
                  {formateToPrecision(((+formatUnits(sale.unitsAvailable, sale.token.decimals))))}
                </span>
              </li>
            </ul>
            {/if}
            {#if canEnd}
            <div class="sale-buttons-wrapper">
              {#await canStart()}
                <button class="sale-btn end-sale" id="sale-detail-start-hidden">
                  Start Sale
                  <img src="./images/btn-load.gif" alt="load" />
                </button>
              {:then canStart}
                <button id="sale-detail-start"
                        class="sale-btn mt-auto {canStart ? 'start-sale' : 'end-sale'}"
                        on:click={() => open(
                  SaleStartModal,
                  { sale:saleContract, isStartSale: true },
                  {},
                  { onClosed: refreshActions }
                )}>
                  Start Sale
                </button>
              {/await}

              {#await canEnd()}
                <button class="sale-btn end-sale mt-auto ml-auto" id="sale-detail-end-hidden">
                  End Sale
                  <img src="./images/btn-load.gif" alt="load" />
                </button>
              {:then canEnd}
                <button id="sale-detail-end"
                        class="sale-btn mt-auto ml-auto {canEnd ? 'start-sale' : 'end-sale'}"
                        on:click={() => open(
                  SaleStartModal,
                  { sale:saleContract, isStartSale: false },
                  {},
                  { onClosed: refreshActions }
                )}>
                  End Sale
                </button>
              {/await}
            </div>
            {/if}
          </div>
        </div>
        {#if sale}
        <div class="form-row">
          <div class="col-6">
            <div class="rise-reserve-token">
              <h2>Raise Token</h2>
              <ul class="list-none flex column-direction">
                <li>
                  Token address:
                  <span class="ml-auto">{addEllipses(sale.token.id)}</span>
                </li>
                <li>
                  Name:
                  <span class="ml-auto">{sale.token.name}</span>
                </li>
                <li>
                  Symbol:
                  <span class="ml-auto">{sale.token.symbol}</span>
                </li>
                <li>
                  Total Supply
                  <span class="ml-auto">
                    {formatUnits(sale.token.totalSupply ?? 0, sale.token.decimals ?? 0)}
                  </span>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-6">
            <div class="rise-reserve-token">
              <h2>Reserve Token</h2>
              <ul class="list-none flex column-direction">
                <li>
                  Token address:
                  <span class="ml-auto">{addEllipses(sale?.reserve?.id)}</span>
                </li>
                <li>
                  Name:
                  <span class="ml-auto">{sale.reserve.name ?? ""}</span>
                </li>
                <li>
                  Symbol:
                  <span class="ml-auto">{sale.reserve.symbol ?? ""}</span>
                </li>
                <li>
                  Total Supply
                  <span class="ml-auto">
                    {formatUnits(sale.reserve.totalSupply ?? 0, sale.reserve.decimals ?? 0)}
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        {/if}
        <div class="transaction-history flex flex-wrap column-direction">
          <h2>Transaction History</h2>
          {#if sale}
          {#await fetchTransactions()}
            <div class="data-load flex items-center flex-text-center">
              <img src="./images/btn-load.gif" alt="" />
            </div>
          {:then transactions}
            {#if transactions.length === 0}
              <p>No transactions found.</p>
            {:else}
              <div class="sale-list-table flex flex-wrap">
                <table>
                  <thead>
                    <tr>
                      <th>Sender</th>
                      <th>Type</th>
                      <th>Time</th>
                      <th>Units</th>
                      <th>Price/rTKN</th>
                      <th>Fee</th>
                      <th>Total</th>
                      <th>Transaction</th>
                    </tr>
                  </thead>
                  <tbody>
                    {#each transactions as transaction}
                      <tr>
                        <td>{addEllipses(transaction.sender)}</td>
                        <td>{typeMap.get(transaction.__typename)}</td>
                        <td>
                          {getUnixTimeStamp(transaction.timestamp, 'MM-DD-YYYY HH:mm:ss')}
                        </td>
                        <td>
                          {formateToPrecision(Number((+formatUnits(transaction.receipt.units, token.decimals))))}
                          {token.symbol}
                        </td>
                        <td>
                          {formateToPrecision(Number((+formatUnits(transaction.receipt.price, reserve.decimals))))}
                          {reserve.symbol}
                        </td>
                        <td>
                          {formateToPrecision(Number((+formatUnits(transaction.receipt.fee, reserve.decimals))))}
                          {reserve.symbol}
                        </td>
                        {#if transaction.__typename == 'SaleBuy'}
                          <td>
                            {formateToPrecision(Number((+formatUnits(transaction.totalIn, reserve.decimals))))}
                            {reserve.symbol}
                          </td>
                        {:else}
                          <td>
                            {formateToPrecision(Number((+formatUnits(transaction.totalOut, reserve.decimals))))}
                            {reserve.symbol}
                          </td>
                        {/if}
                        <td class="py-2 text-right">
                          <a id="sale-detail-transaction"
                            href={`blockexplorer/tx/${transaction.transactionHash}`}
                            target="_blank">
                            {addEllipses(transaction.transactionHash)}
                            <img
                              class="outside"
                              src="./images/outside.svg"
                              alt="outside" />
                          </a>
                        </td>
                      </tr>
                    {/each}
                  </tbody>
                </table>
              </div>
            {/if}
          {/await}
          {/if}
        </div>
      </div>
    </div>
  {:else if inValid}
    <div class="no-project-wrapper relative">
      <img src="/images/no_project.svg" alt="no-project" />
      <div class="no-project-content flex column-direction items-center">
        <h2>Something went wrong.</h2>
        <p>Invalid contract or retry again after some time</p>
        <a href="/" id="return-to-home" class="btn-gradient-background btn-return-home">
          Return to Home
        </a>
      </div>
    </div>
  {:else}
    <div class="loader flex items-center flex-text-center">
      <img src={loaderGif} alt="Loading..." />
    </div>
  {/if}
{:else}
  <ConnectWallet />
{/if}